import { FEATURES } from '@/access/features';
import { loadView } from '@/router/routerHelpers';
import {
  PAGES_PREVIEW_PATH,
  PAGES_PREVIEW_ROUTE,
} from '@/components/pages/pagesPreview';

export function isPagesPlaygroundOpen(nodeEnv = process.env.NODE_ENV) {
  return nodeEnv === 'development';
}

function playgroundBeforeEnter(to, from, next) {
  if (!isPagesPlaygroundOpen()) {
    next({ name: 'home' });
    return;
  }
  next();
}

const pagesRoutes = [
  {
    path: '/pages/playground',
    name: 'pages-playground',
    meta: {
      showNav: true,
      features: [FEATURES.PAGES, FEATURES.PAGES_PREVIEW],
    },
    beforeEnter: playgroundBeforeEnter,
    component: loadView('pages/PagesPlayground'),
  },
  {
    path: PAGES_PREVIEW_PATH,
    name: PAGES_PREVIEW_ROUTE,
    meta: {
      showNav: true,
      feature: FEATURES.PAGES_PREVIEW,
    },
    component: loadView('pages/PagesTreeView'),
    props: { preview: true },
  },
  {
    path: '/pages/:section/:leaf(.*)?',
    name: 'pages-slug',
    meta: {
      showNav: true,
      features: [FEATURES.PAGES, FEATURES.PAGES_PREVIEW],
    },
    component: loadView('pages/PagesTreeView'),
    props: true,
  },
];

export default pagesRoutes;
